import { UpdateFunctionInput, CreateFunctionInput } from "../validation/function"
import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});
// Function to handle fetch requests
export async function fetchDataApi(url: string, options: RequestInit = {}): Promise<any> {
   

    try {
        const response = await authService.apiCall(`${BASE_URL}/${url}`, {
            ...options,
         
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function fetchAllDataApi(): Promise<any> {
    try {

        const response = await authService.apiCall(`${BASE_URL}/functions/getAll`, {
            method: "GET",

        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function fetchcontrolReference(): Promise<any> {
    try {
      
        const response = await authService.apiCall(`${BASE_URL}/control-references?query=${""}&perPage=${99999999999999999}&pageNo=${0}`, {
          method: "GET",
          
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function createFunctionApi(body: CreateFunctionInput): Promise<void> {
    try {
      
        const response = await authService.apiCall(`${BASE_URL}/functions`, {
         method: "POST",
           
            body: JSON.stringify(body),
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to create");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function updateFunctionApi(id: string, body: UpdateFunctionInput): Promise<void> {
    try {
      
        const response = await authService.apiCall(`${BASE_URL}/functions/${id}`, {
            method: "PATCH",
         
            body: JSON.stringify(body),
        });
        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to create");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export async function deleteFunctionApi(id: string): Promise<void> {
    try {
        const response = await authService.apiCall(`${BASE_URL}/functions/${id}`, {
            method: "DELETE",
        });
      
        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to create");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}


export async function getFunCount(): Promise<any> {
    try {
       
        const response = await authService.apiCall(`${BASE_URL}/functions/count`, {
          method: "GET",
          
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
            if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
                throw new Error("Forbidden: You do not have permission to access this resource.");
            }
            throw new Error("Failed to fetch");
        }
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}
